import axios from 'axios';

export const axiosIntance = axios.create({
    baseURL : "https://azero-atbbauacgqehcpgc.canadacentral-01.azurewebsites.net/api/v1",
    withCredentials : true
})